/**
 * This file overwrites chatty function
 */


/**
 * If submenu has another submenu put it in a
 * div with id nav-nth-level
 *
 * Places nth submenu on page
 * only implemented for 3rd level right now
 */
function writeNavNthLevel(nthLevel) {

    // new: if has megamenu not necessary
    if(jQuery('.submenu-full-width').length > 0) {
        return;
    }

    // set default to 3rd
    var nthLevel = nthLevel || 3;

    // Check if there are nth - 1 li.dropdown active
    // => there is a nth navigation level
    var activeDropdown = jQuery('div.main-menu').find('li.dropdown.active');

    if( jQuery(activeDropdown).length == nthLevel - 1) {
        
        // clone dropdown as we will display it on mobile also in main navigation
        var activeDropdownClone = jQuery(activeDropdown).clone();

        // show nth-Navigation
        // new: changed from block to display flex (back to block see multiple lines
        jQuery('#header-nav-'+nthLevel).css( {'display' : 'block' } );

        // Get Name of active page (nth - 1 level)
        jQuery( '#head-nav-'+nthLevel ).text( jQuery(activeDropdownClone).last().children('a').text() );

        // get menu nth-Level | remove class dropdown-menu because this is set to display none
        jQuery('#nav-level-'+nthLevel ).html( jQuery(activeDropdownClone).last().children('ul').removeClass('dropdown-menu'));
    }
}

//
// HEADER CAROUSEL | SLIDER
// -----------------------------------------------------
function sliderHeaderSetWidthOfImage() {

    // do nothing (width is set with css)

    // var widthContainer = jQuery('#carousel-header .item.default .container').width();
    // var widthMarginBrowser = (window.browserWidthImageSlider - widthContainer) / 2;
    // var widthDivImage = widthContainer - (widthContainer * 0.414) + widthMarginBrowser;
    //
    // jQuery('#carousel-header .item.default .slider-image').each(function() {
    //     jQuery(this).css('width', parseInt(widthDivImage) + 'px');
    // });
}

/**
 * Set divs in slider to height
 *
 * all slides should have the same height
 *
 * For header slider mobile
 *
 * different handling:
 * 1) elements are stacked on top of each other
 * 2) no background image
 */
function sliderHeaderXsSameHeight(height, init) {

    init = init || false;

    jQuery('#carousel-header-xs .item .slider-text').css('height', height + 'px');

    // set control arrows of half of image (it is asumed that all images have the same height)

    // if onload wait till images has loaded
    if(init) {

        /**
         * ideal img is dynamically loaded
         * wait for load and then get height
         * get actual height because inactive elements are hidden
         */
        // New: needed to change .load() to .on('load'..
        jQuery("#carousel-header-xs img").on('load',function(){

            var heightImage = jQuery(this).actual('height');

            jQuery('#carousel-header-xs .carousel-control span').css('top',  parseInt(heightImage / 2) + 'px');

            /**
             * set control circles at bottom of image (it is asumed that all images have the same height)
             */
            jQuery('#carousel-header-xs .carousel-indicators').css({ 'bottom' : 'auto', 'top' : parseInt(heightImage -30 ) + 'px' });
        });
    }
    else {

        var heightImage =  jQuery("#carousel-header-xs img").actual('height');

        jQuery('#carousel-header-xs .carousel-control span').css('top',  parseInt(heightImage / 2) + 'px');

        /**
         * set control circles at bottom of image (it is asumed that all images have the same height)
         */
        jQuery('#carousel-header-xs .carousel-indicators').css({ 'bottom' : 'auto', 'top' : parseInt(heightImage -30 ) + 'px' });
    }
}

function initSectionCollapse() {

    var countSection = 0;
    var allSections = jQuery('section[id]');

    /**
     * get all <section> with id
     */
    jQuery(allSections).each( function(index, section) {

        /**
         * first section is the introduction of the page => skip collapse
         */
        if( countSection > 0) {

            var idSection = jQuery(section).attr('id');

            /**
             * check if there are link <a> to the <section> id
             * if there are it is assumed that it is a page with a lot of content
             * which should collapse on mobile
             */
            var linkToSection = jQuery(`a[href="#jQuery{idSection}"]`);

            if( jQuery(linkToSection).length > 0) {

                var sectionName = jQuery(linkToSection).html();
                /**
                 * add html teaser before section
                 */
                jQuery(section).before(` 
                    
                    <div class="section-teaser clearfix v-center" data-id-section="jQuery{idSection}">
                        <h2 class="h3"><a>jQuery{sectionName} <span class="glyphicon glyphicon-einfacher-pfeil-runter right" aria-hidden="true"></span></a></h2>
                    </div>                   
               `);

                /**
                 * hide section on init
                 */
                jQuery(section).addClass('hide');

                /**
                 * if last section add line after section
                 */
                if(countSection == jQuery(allSections).length - 1) {

                    jQuery(section).after('<div class="section-teaser last"></div>');
                }
            }
        }
        countSection ++;
    });

    /**
     * arrow element vertical align
     */
    sectionTeaserAdjust();

    /**
     * event Listener on new section teaser elements
     */
    jQuery('.section-teaser').click( function() {
        showHideSection( jQuery(this).attr('data-id-section') );
    });
}